import { useEffect } from "react";
import { useMatches } from "react-router-dom";
import { APP_TITLE, APP_HOME_TITLE, getDynamicTitle } from "@/hooks/usePageTitle";

type RouteHandle = { title?: string };

// Reads the deepest matched route whose handle declares `title` and writes
// `<title> · ELGW 5` to document.title. If no match declares a title (root
// dashboard, detail pages that set their own via usePageTitle), falls back to
// APP_HOME_TITLE. Re-runs on every route change.
export function PageTitle() {
  const matches = useMatches();
  useEffect(() => {
    const titled = [...matches]
      .reverse()
      .find((m) => (m.handle as RouteHandle | undefined)?.title);
    const title = (titled?.handle as RouteHandle | undefined)?.title;
    // Strona, która sama liczy tytuł z danych (usePageTitle), ma pierwszeństwo — inaczej
    // zmiana ?tab= na tej samej trasie kasowałaby nazwę projektu z karty przeglądarki.
    const dynamic = getDynamicTitle();
    document.title = dynamic
      ? `${dynamic} · ${APP_TITLE}`
      : title
        ? `${title} · ${APP_TITLE}`
        : APP_HOME_TITLE;
  }, [matches]);
  return null;
}
